module.exports = __webpack_public_path__ + "img/banner2.c998ff93.jpg";